import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import NavLink from '../nav_link';
import AgentList from './maList--administration-agents';
import UserList from './maList--administration-users';
import BackupList from './maList--administration-backups';

const styles = () => ({
    subheading: {
        paddingLeft: '32px',
        maxHeight: '40px',
        paddingRight: '1.0rem',
    },
    subheadingActive: {
        maxHeight: '40px',
        color: 'rgba(0, 0, 0, 0.95)',
        fontSize: '0.875rem',
        lineHeight: '1.46429em',
        fontWeight: 'bold',
    },
    chevron: {
        fill: '#262626',
        marginRight: '-1rem',
    },
});

class MAListAdministration extends React.Component {
    state = {
        openAgents: false,
        openUsers: false,
        openBackups: false,
    };
    handleClickUsers = (event) => {
        let current = !this.state.openUsers;
        if (!event) {
            current = true;
        }
        this.setState({
            openUsers: current,
        });
    };
    handleClickAgents = (event) => {
        let current = !this.state.openAgents;
        if (!event) {
            current = true;
        }
        this.setState({
            openAgents: current,
        });
    };
    handleClickBackups = (event) => {
        let current = !this.state.openBackups;
        if (!event) {
            current = true;
        }
        this.setState({
            openBackups: current,
        });
    };
    preventAction = (e) => {
        e.preventDefault();
    };

    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Collapse component="li" in={this.props.isOpen} timeout="auto">
                    <List disablePadding>
                        <NavLink
                            onClick={this.preventAction}
                            to="/manager-agents/administration/agents/"
                            onActive={this.props.onActive}
                        >
                            <ListItem button onClick={this.handleClickAgents} className={classes.subheading}>
                                <ListItemText secondary="Agents" />
                            </ListItem>
                        </NavLink>

                        <AgentList
                            handleDrawerToggle={this.props.handleDrawerToggle}
                            onActive={() => {
                                this.handleClickAgents();
                                this.props.onActive();
                            }}
                        />

                        <NavLink
                            onClick={this.preventAction}
                            to="/manager-agents/administration/users/"
                            onActive={this.props.onActive}
                        >
                            <ListItem button onClick={this.handleClickUsers} className={classes.subheading}>
                                <ListItemText secondary="Users" />
                            </ListItem>
                        </NavLink>

                        <UserList
                            handleDrawerToggle={this.props.handleDrawerToggle}
                            onActive={() => {
                                this.handleClickUsers();
                                this.props.onActive();
                            }}
                        />

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/administration/dashboard"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Manager Dashboard" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/administration/application-updates"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Application Updates" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/administration/backups"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Manager Backup" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/administration/database-alarms"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Database Alarms" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/administration/directory-services"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Directory Services" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/administration/health-check"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Health Check" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/administration/logs"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Transfer and Web Logging" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/administration/menu-configuration"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Menu Configuration" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/administration/organizations"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Organizations" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/administration/about-resource-controls"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="About Resource Controls" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/administration/resource-controls"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Using Resource Controls" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/administration/system-health"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="System Health" />
                            </ListItem>
                        </NavLink>
                    </List>
                </Collapse>
            </React.Fragment>
        );
    }
}

MAListAdministration.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default withStyles(styles)(MAListAdministration);
